import { call, put } from '@redux-saga/core/effects';
import { api, apiErrorHandler, notify } from 'services';
import {
  UpdateWarehouseAreasActions as Actions,
  UpdateWarehouseAreasRequestAction as RequestAction,
} from 'store/ducks/warehouseAreas';

export function* updateWarehouseAreasRequest(action: any) {
  const { warehouseId, areaIds, onSuccess, onFailure }: RequestAction = action;
  try {
    const { data } = yield call(api.put, `warehouses/${warehouseId}/areas`, {
      areas: areaIds,
    });
    onSuccess && onSuccess();
    notify('success', 'Áreas do armazém atualizadas com sucesso');
    yield put(Actions.success(data));
  } catch (error) {
    const { errorMessage, validationErrors } = apiErrorHandler(error);
    onFailure && onFailure();
    /**
     * O `ValidationException` devolve uma mensagem genérica e o motivo real em
     * `validationErrors`. Como este seletor não vive dentro de um `Form`, o
     * `useValidation` não tem campo para pintar o erro — a notificação é o único
     * lugar onde o motivo do bloqueio chega ao usuário.
     */
    notify('error', validationErrors?.[0]?.message ?? errorMessage);
    yield put(Actions.failure(errorMessage, validationErrors));
  }
}
